<template>
  <!-- Variant for ForgotPassword/ResetPassword with section wrapper -->
  <div v-if="variant === 'section'" class="auth-header-section">
    <div class="auth-logo">
      <AgentGridMark v-if="isAgentGridAuth" />
      <img v-else src="@/assets/illustrations/anima-logo-new.svg" alt="Anima" width="36" height="36" />
    </div>
    <div class="auth-header-text">
      <h1 class="auth-title">{{ title }}</h1>
      <h2 class="auth-subtitle">{{ subtitle }}</h2>
    </div>
  </div>

  <!-- Default variant for Login/Signup -->
  <div v-else class="auth-header">
    <div class="auth-logo">
      <AgentGridMark v-if="isAgentGridAuth" />
      <img v-else src="@/assets/illustrations/anima-logo-new.svg" alt="Anima" width="36" height="36" />
    </div>
    <h1 class="auth-title">{{ title }}</h1>
    <h2 class="auth-subtitle">{{ subtitle }}</h2>
  </div>
</template>

<script>
import AgentGridMark from './AgentGridMark';
import AuthBrandMixin from '@/mixins/AuthBrandMixin';

/**
 * AuthFormHeader Component
 *
 * Reusable header component for all auth flows (Login, Signup, ForgotPassword, ResetPassword).
 * Displays logo, title, and subtitle consistently across views. Renders the Agent Grid mark
 * instead of the Anima logo when the flow was started from Agent Grid.
 *
 * @prop {string} title - Main heading text (required)
 * @prop {string} subtitle - Subheading text (required)
 * @prop {string} variant - Layout variant: 'default' for Login/Signup, 'section' for ForgotPassword/ResetPassword
 *
 * @example
 * // Default variant (Login/Signup)
 * <AuthFormHeader title="Welcome back" subtitle="Log in to your account to continue building." />
 *
 * @example
 * // Section variant (ForgotPassword/ResetPassword)
 * <AuthFormHeader variant="section" title="Forgot your password?" subtitle="We'll email you a password reset link." />
 */
export default {
  name: 'AuthFormHeader',
  mixins: [AuthBrandMixin],
  components: {
    AgentGridMark
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'section'].includes(value)
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/_auth.scss';
</style>
